var map = {
	"./arabic.json": 728,
	"./english.json": 729,
	"./greek.json": 730,
	"./indonesian.json": 731,
	"./malay.json": 732
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 218;


//////////////////
// WEBPACK FOOTER
// ./src/locales/fun2win ^\.\/.*\.json$
// module id = 218
// module chunks = 0